import React from 'react';
import MenuCollapseItem from '../../MenuCollapseItem';
import { useMenu } from '../DesktopMenu';
import { UseCollapseReturn } from '../MobileMenu';
import RouteKey from '../../../routes/key';

const { admin } = RouteKey.child;

const { tasklist, requestlist } = RouteKey.admin.child;

const adminPersonalPathDetails = [`/${admin}/${tasklist.route}`, `/${admin}/${requestlist.route}`];

const PersonalMenuItem = ({
  collapseMenuItem11,
  menu11Handle,
  setMobileMenuOpen,
}: {
  collapseMenuItem11: UseCollapseReturn;
  menu11Handle: (evt: any) => void;
  setMobileMenuOpen: (value: boolean) => void;
}) => {
  const { history, checkMenuPathsInLocation, checkSubMenuPathInLocation } = useMenu();

  return (
    <MenuCollapseItem
      {...collapseMenuItem11}
      handleClick={menu11Handle}
      label="Personal"
      subMap={[
        {
          label: 'My Tasks',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${tasklist.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${tasklist.route}`),
        },
        {
          label: 'My Requests',
          navigate: () => {
            setMobileMenuOpen(false);
            history.push(`/${admin}/${requestlist.route}`);
          },
          isActiveSubMenu: checkSubMenuPathInLocation(`/${admin}/${requestlist.route}`),
        },
      ]}
      isActiveMenu={checkMenuPathsInLocation(adminPersonalPathDetails)}
    />
  );
};

export default PersonalMenuItem;
